module.exports = __webpack_public_path__ + "img/submit_policy.ad382a34.png";